import moment from 'moment';
import { isNil } from 'ramda';

import PropTypesPresenter from '../utils/PropTypesPresenter';

export const SHORT_FORMAT = 'YYYY-MM-DD';
const US_SHORT_FORMAT = 'YYYY/MM/DD';
const DETAILED_DATE_FORMAT = 'MM-DD-YYYY h:mm a';
const READABLE_FORMAT = 'MMM dd yyyy';
const HOUR_FORMAT = 'h:mma';
export const HUMAN_FORMAT = 'll';
export const RANGE_FORMAT = 'MMM dd yyyy';

export default new PropTypesPresenter(
  {},
  {
    detailedFormattedDate(date) {
      return moment(date).format(DETAILED_DATE_FORMAT);
    },
    shortFormattedDate(date) {
      return moment(date).format(SHORT_FORMAT);
    },
    americanShortFormattedDate(date) {
      return moment(date).format(US_SHORT_FORMAT);
    },
    readableFormattedDate(date) {
      return moment(date).format(READABLE_FORMAT);
    },
    humanFormattedDate(date) {
      return moment(date).format(HUMAN_FORMAT);
    },
    humanizeHour(hour) {
      if (hour) {
        return moment().hour(hour).startOf('hour').format(HOUR_FORMAT);
      }
      return '';
    },
    today() {
      return moment().format(SHORT_FORMAT);
    },
    daysAhead(numberOfDays) {
      return moment().add(numberOfDays, 'days').format(SHORT_FORMAT);
    },
    oneMonthAgo() {
      return moment().subtract(1, 'months').format(SHORT_FORMAT);
    },
    oneMonthAhead() {
      return moment().add(1, 'months').format(SHORT_FORMAT);
    },
    dateObject(date) {
      return moment(date).toDate();
    },
    dateReadable(date) {
      if (isNil(date)) return '--';

      return this.shortFormattedDate(date);
    },
    workingHours(openingHour, closingHour) {
      return `${this.humanizeHour(openingHour)} - ${this.humanizeHour(
        closingHour
      )}`;
    },
  }
);
